/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : DashboardVehicleSystem.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import React, { useEffect, useState } from "react";
import { componentStyle } from "../../../../../config/appTheme";
import { Box, MenuItem } from "@mui/material";
import CustomDataGridV2 from "../../../common/datagrid/CustomDataGridV2";
import { useNavigate } from "react-router-dom";

function DashboardVehicleSystem({
  recentActivitiesDetails,
  getUserFullNameById,
}) {
  const navigate = useNavigate();
  const [vsTableRowData, setVsTableRowData] = useState([]);
  const vsComponentDetails = recentActivitiesDetails.vsDetails || [];
  const [enableMore, setEnableMore] = useState([]);

  useEffect(() => {
    if (vsComponentDetails) {
      setEnableMore(vsComponentDetails.length > 5);
      const filteredeeComponentDetails = vsComponentDetails
        ?.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
        ?.slice(0, 5)
        ?.map((item) => ({
          id: item?.id,
          assembly_number: item?.assembly_number,
          name: item?.name,
          description: item?.description,
          created_by: item?.created_by,
          updated_at: item?.updated_at,
          allData: item,
        }));

      setVsTableRowData(filteredeeComponentDetails);
    } else {
      setVsTableRowData([]);
    }
  }, [vsComponentDetails]);

  const VS_COLUMNS = [
    {
      field: "name",
      headerName: "Name",
      flex: 1,

      renderCell: (params) => (
        <Box sx={{ ...componentStyle.font.tableText }}>
          {params?.value || "-"}
        </Box>
      ),
    },

    {
      field: "assembly_number",
      headerName: "Assembly Number",
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ ...componentStyle.font.tableText }}>
          {params?.value || "-"}
        </Box>
      ),
    },
    {
      field: "description",
      headerName: "DESCRIPTION",
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ ...componentStyle.font.tableText }}>
          {params?.value || "-"}
        </Box>
      ),
    },

    {
      field: "created_by",
      headerName: "Owner",
      flex: 1,
      renderCell: (params) => (
        <Box sx={{ ...componentStyle.font.tableText }}>
          {getUserFullNameById(params?.value || "-")}
        </Box>
      ),
    },
  ];

  return (
    <Box sx={{ height: "450px", width: "100%" }}>
      <CustomDataGridV2
        columns={VS_COLUMNS}
        rows={vsTableRowData}
        enableMore={enableMore}
        handleMore={() => {
          navigate("/dashboard/labcar");
        }}
      />
    </Box>
  );
}

export default DashboardVehicleSystem;
